import axios from "axios";

const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
  // withCredentials: true, // optional: if using cookies for auth
});
apiClient.interceptors.request.use((config) => {
  // const token: LoginAccount | null = sessionStorage.getItem("authToken")
  //   ? getTokenPayloadSafely(sessionStorage.getItem("authToken") as string)
  //   : null;
  if (sessionStorage.getItem("authToken")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${sessionStorage.getItem(
      "authToken"
    )}`;
  }
  return config;
});

export default apiClient;
